import * as actionTypes from "../actionTypes";

const initialState = {
  loading: false,
  contentList: null,
  error: null,
  success: null
};

export const contentReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_CONTENT_LIST_START:
      return {...state, loading: true, error: null, contentList: null};
    case actionTypes.GET_CONTENT_LIST_SUCCESS:
      return {...state, loading: false, error: null, success: null, contentList: action.payload};
    case actionTypes.GET_CONTENT_LIST_FAILURE:
      return {...state, loading: false, error: action.payload, success: null, contentList: null};
    // create content
    case actionTypes.ADD_CONTENT_START:
      return {...state, loading: true, error: null, success: null};
    case actionTypes.ADD_CONTENT_SUCCESS:
      return {...state, loading: false, error: null, success: action.payload.success};
    case actionTypes.ADD_CONTENT_FAILURE:
      return {...state, loading: false, error: action.payload.error, success: null, contentList: null};
      case actionTypes.Edit_CONTENT:
        return {...state, loading: true, error: null, success: null};

    // upload contents list
    case actionTypes.UPLOAD_CONTENTS_LIST_START:
      return {...state, loading: true, error: null, success: null};

    case actionTypes.GET_CONTENT_MESSAGE_HANDLER:
      return {...state, error: action.payload, success: action.payload,};
    default:
      return {...state};
  }
};
